export default function authHeader() {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user && user.value[0].token) {
    return { Authorization: "Bearer " + user.value[0].token };
  } else {
    return {};
  }
}
